
import {
  Component,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSnackBar } from '@angular/material/snack-bar'; // ← ADDED
import { callback } from 'chart.js/dist/helpers/helpers.core';

export interface PurchasedAppItem {
  id: number;
  applicationName: string;
  ownerName: string;
  accessKey: string;
  status: string;
  createdDatetime: string;
  userFirstname: string;
  organizationName: string;
}

interface TableColumn {
  key: string;
  label: string;
  sortable: boolean;
}

@Component({
  selector: 'app-app-bought',
  templateUrl: './app-bought.component.html',
  styleUrls: ['./app-bought.component.css'],
})
export class AppBoughtComponent extends BaseListCtl {
  // Define all columns with their properties
  allColumns: TableColumn[] = [
    { key: 'sno', label: 'APP_PURCHASED.TABLE.SNO', sortable: false },
    {
      key: 'applicationName',
      label: 'APP_PURCHASED.TABLE.APP',
      sortable: true,
    },
    { key: 'ownerName', label: 'APP_PURCHASED.TABLE.OWNER', sortable: true },
    {
      key: 'accessKey',
      label: 'APP_PURCHASED.TABLE.ACCESS_KEY',
      sortable: false,
    },
    { key: 'status', label: 'APP_PURCHASED.TABLE.STATUS', sortable: true },
    {
      key: 'createdDatetime',
      label: 'APP_PURCHASED.TABLE.DATE',
      sortable: true,
    },
    { key: 'action', label: 'APP_PURCHASED.TABLE.ACTION', sortable: false },
  ];

  // Default column order
  defaultColumnOrder: string[] = this.allColumns.map((col) => col.key);
  // Store current column order
  displayedColumns: string[] = [...this.defaultColumnOrder];

  /** Holds table rows */
  dataSource: PurchasedAppItem[] = [];

  @ViewChild('input') input!: ElementRef;

  /** SORT STATE */
  currentSortColumn = '';
  currentSortDirection: 'asc' | 'desc' | '' = '';

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private snackBar: MatSnackBar
  ) {
    super('', locator, route);

    locator.config.getProperty('endpoint.userapps').then((property: string) => {
      this.initApiEndpoint(property);
    });
  }

  override search() {
    this.display();
  }

  override ngOnInit() {
    // Restore saved column order from localStorage
    this.restoreColumnOrderFromStorage();

    this.locator.config
      .getProperty('endpoint.application')
      .then((property: string) => {
        // this.preload();
        this.search();
        this.display();
      });
  }

  /** -------------------------------
   * API CALL
   * -------------------------------*/
  // display() {
  //   const url = this.locator.getEndpoint('endpoint.userapps') + '/bought';

  //   this.locator.http.get(url, (res: any, error: boolean) => {
  //     if (error) {
  //       alert('Server error: ' + error);
  //       return;
  //     }

  //     this.form.list = res.result.data || [];
  //     this.dataSource = [...this.form.list];

  //     // Trigger change detection after data load
  //     this.cdRef.detectChanges();
  //   });
  // }

  display() {
    let _self = this;

    const url =
      this.locator.getEndpoint('endpoint.userapps') +
      '/boughtApp/' +
      _self.form.pageNo;

    console.log('url : ', url);

    _self.form.searchParams['pageSize'] = _self.form.pageSize;

    console.log(_self.form.searchParams);

    this.locator.http.post(
      url,
      _self.form.searchParams,
      (res: any, error: boolean) => {
        if (error) {
          // Show error in snackbar
          _self.showSnackbar('Server Error: ' + error, 'error');
          // Also update form.message for alert box (original functionality)
          _self.form.message = 'Server Error:' + error;
          _self.form.error = true;
          return;
        }

        // Store original data
        _self.form.list = res.result.data || [];

        _self.form.pageCount = res.result.pageCount;
        _self.form.pageSize = res.result.pageSize;
        _self.form.pageNoList = [];

        // Build page number list (original functionality)
        for (let i = 0; i < _self.form.pageCount; i++) {
          _self.form.pageNoList.push(i);
        }

        // Check empty list (original functionality)
        if (_self.form.list.length == 0) {
          _self.form.message = 'No record found';
          _self.form.error = true;
        } else {
          _self.form.message = '';
          _self.form.error = false;
        }

        // Update form status (original functionality)
        _self.form.error = !res.success;
        _self.form.message = res.message || _self.form.message;

        _self.cdRef.detectChanges();
      }
    );
  }

  /** -------------------------------
   * COLUMN ORDER FUNCTIONS
   * -------------------------------*/

  // Get current columns in correct order
  getCurrentColumns(): TableColumn[] {
    return this.displayedColumns
      .map((key) => this.allColumns.find((col) => col.key === key))
      .filter((col) => col) as TableColumn[];
  }

  // Restore column order from localStorage
  private restoreColumnOrderFromStorage() {
    const saved = localStorage.getItem('appBoughtColumnOrder');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        // Validate that all required columns are present
        const requiredColumns = this.allColumns.map((col) => col.key);
        const isValid =
          requiredColumns.every((col) => parsed.includes(col)) &&
          parsed.length === requiredColumns.length;

        if (isValid) {
          this.displayedColumns = parsed;
        }
      } catch (e) {
        console.warn('Failed to parse saved column order:', e);
        this.resetToDefaultOrder();
      }
    }
  }

  // Reset to default column order
  private resetToDefaultOrder() {
    this.displayedColumns = this.allColumns.map((col) => col.key);

    // Clear localStorage
    localStorage.removeItem('appBoughtColumnOrder');

    // Trigger UI refresh
    this.cdRef.detectChanges();
  }

  // Column drag and drop handler
  drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex === event.currentIndex) return;

    moveItemInArray(
      this.displayedColumns,
      event.previousIndex,
      event.currentIndex
    );

    // Save user's choice with a unique key for this component
    localStorage.setItem(
      'appBoughtColumnOrder',
      JSON.stringify(this.displayedColumns)
    );

    // Trigger UI refresh
    this.cdRef.detectChanges();
  }

  // Check if column order has been changed
  isColumnOrderChanged(): boolean {
    return (
      JSON.stringify(this.displayedColumns) !==
      JSON.stringify(this.defaultColumnOrder)
    );
  }

  // Public restore method for button click
  restoreColumnOrder() {
    if (
      confirm(
        'Are you sure you want to reset all columns to their default positions?'
      )
    ) {
      this.resetToDefaultOrder();
      this.showSnackbar('Column order restored successfully!', 'success');
    }
  }

  // ← ADD SNACKBAR METHOD HERE
  private showSnackbar(
    message: string,
    type: 'success' | 'error' | 'info' = 'info'
  ) {
    const panelClass =
      type === 'success'
        ? 'success-snackbar'
        : type === 'error'
        ? 'error-snackbar'
        : 'info-snackbar';

    this.snackBar.open(message, 'Close', {
      duration: 4000,
      verticalPosition: 'top',
      // horizontalPosition: 'right',
      panelClass: [panelClass],
    });
  }

  /** Extract correct sorting value */
  getSortValue(item: PurchasedAppItem, property: string) {
    switch (property) {
      case 'app':
        return item.applicationName?.toLowerCase() || '';
      case 'owner':
        return item.ownerName?.toLowerCase() || '';
      case 'accessKey':
        return item.accessKey?.toLowerCase() || '';
      case 'status':
        return item.status?.toLowerCase() || '';
      case 'date':
        return new Date(item.createdDatetime).getTime();
      default:
        return '';
    }
  }

  /** -------------------------------
   * SEARCH FILTER
   * -------------------------------*/
  applyFilter(event: Event) {
    const search = (event.target as HTMLInputElement).value.toLowerCase();

    if (!this.form.list) return;

    if (!search) {
      // Reset to original data
      this.dataSource = [...this.form.list];
      return;
    }

    this.dataSource = this.form.list.filter(
      (data: PurchasedAppItem) =>
        data.applicationName?.toLowerCase().includes(search) ||
        data.ownerName?.toLowerCase().includes(search) ||
        data.accessKey?.toLowerCase().includes(search) ||
        data.status?.toLowerCase().includes(search) ||
        data.userFirstname?.toLowerCase().includes(search) ||
        data.organizationName?.toLowerCase().includes(search)
    );
  }

  clearSearch() {
    if (this.input?.nativeElement) {
      this.input.nativeElement.value = '';
    }
    this.dataSource = [...this.form.list];
  }

  /** Serial number */
  // override pageIndex(i: number) {
  //   return i + 1;
  // }

  /** Status badge class */
  getStatusClass(status: string): string {
    if (!status) return 'status-default';

    const statusLower = status.toLowerCase().trim();

    switch (statusLower) {
      case 'approved':
      case 'active':
        return 'status-approved';
      case 'pending':
        return 'status-pending';
      case 'rejected':
      case 'inactive':
        return 'status-rejected';
      case 'cancelled':
        return 'status-cancelled';
      case 'hold':
        return 'status-hold';
      case 'blocked':
        return 'status-blocked';
      case 'no status':
      default:
        return 'status-default';
    }
  }

  goto(id: number) {
    this.forward('appboughtdata/' + id);
  }

  isExpanded = false;
  toggleSearch() {
    this.isExpanded = !this.isExpanded;
  }

  sortedField: string | null = null;
  sortOrder: 'ASC' | 'DESC' | null = null;
  sortTable(field: string): void {
    console.log('Hello sort');
    let _self = this;
    if (this.sortedField === field) {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortedField = field;
      this.sortOrder = 'ASC';
    }
    _self.form.searchParams['orderBy'] = this.sortedField;
    _self.form.searchParams['asc'] = this.sortOrder;
    _self.display();
  }

  /** ------------------ SEARCH FILTER --------------------*/

  public AppList: any[] = [];
  applicationName: string = '';
  ownerName: string = '';
  accessKey: string = '';
  status: string = '';
  createdDatetime: string = '';

  searchBought() {
    console.log('Hello world : i am in bought component');

    const url = this.locator.getEndpoint('endpoint.userapps') + '/appBought';

    if (this.applicationName?.trim()) {
      this.form.searchParams['applicationName'] = this.applicationName.trim();
    }

    if (this.ownerName?.trim()) {
      this.form.searchParams['ownerName'] = this.ownerName.trim();
    }

    if (this.accessKey?.toString().trim()) {
      this.form.searchParams['accessKey'] = this.accessKey.toString().trim();
    }

    if (this.createdDatetime?.toString().trim()) {
      this.form.searchParams['createdDatetime'] = this.createdDatetime
        .toString()
        .trim();
    }

    if (this.status?.toString().trim()) {
      this.form.searchParams['status'] = this.status.toString().trim();
    }

    console.log('Search Payload : ', this.form.searchParams);
    console.log('url : ', url);

    this.locator.http.post(
      url,
      this.form.searchParams,
      (res: any, error: boolean) => {
        if (error) {
          alert('Server Error: ' + error);
          this.AppList = [];
          return;
        }

        this.AppList = res.result?.data || [];
        this.form.list = this.AppList;
        console.log('Filtered User List:', this.AppList);
      }
    );
  }

  resetFilters() {
    this.applicationName = '';
    this.ownerName = '';
    this.accessKey = '';
    this.createdDatetime = '';
    this.status = '';

    // 🔹 Clear backend search params
    this.form.searchParams = {};
    this.form.pageNo = 0;

    this.display();
  }
}
